import React, { useEffect, useState } from "react";
import { Modal, Image, Typography, Row, Col } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import "./RoomPopup.css";
import { IMAGE_BASE_URL } from "../../../../constants/api";

const { Title, Paragraph } = Typography;

const RoomPopup = ({ visible, onClose, room = null }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const amenities = room?.room_facility || [];

  if (!room) return null;

  const handleImageClick = (path) => {
    setSelectedImage(path);
  };

  return (
    <Modal
      open={visible}
      footer={null}
      onCancel={onClose}
      centered
      closable={false}
      width={1100}
      className="room-popup-modal"
    >
      <div className="popup-container">
        <div className="popup-close" onClick={onClose}>
          <CloseCircleFilled style={{ fontSize: 32 }} />
        </div>

        {/* Gallery Layout */}
        <div className="image-gallery-row">
          <div className="left-preview">
            <Image
              src={
                selectedImage
                  ? `${IMAGE_BASE_URL}${selectedImage}`
                  : `${IMAGE_BASE_URL}${room.room_images[0].image.filePath}`
              }
              alt="Selected Room Image"
              preview={false}
              className="big-preview-img"
            />
          </div>
          <div className="right-thumbnails">
            {room?.room_images?.map((imgObj, i) => (
              <div
                key={i}
                className={`thumbnail-wrapper ${
                  selectedImage === imgObj.image.filePath ? "active" : ""
                }`}
                onClick={() => handleImageClick(imgObj.image.filePath)}
              >
                <Image
                  src={`${IMAGE_BASE_URL}${imgObj.image.filePath}`}
                  alt={`Thumb ${i}`}
                  preview={false}
                  className="thumbnail-img"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="popup-details">
          <Title level={3}>{room?.room_name}</Title>
          <div
            dangerouslySetInnerHTML={{
              __html: room?.room_description ?? "",
            }}
          ></div>

          <Title level={4}>Accommodation Amenities</Title>
          <Row gutter={[16, 8]}>
            {amenities.map((item, idx) => (
              <Col xs={24} sm={12} md={8} key={idx}>
                <p className="amenity-item">
                  <img
                    alt={item.facility.title}
                    src={IMAGE_BASE_URL + item.facility.web_image?.filePath}
                    style={{
                      height: 30,
                      margin: "20px",
                    }}
                  />
                  {item.facility.title}
                </p>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </Modal>
  );
};

export default RoomPopup;
